export default __webpack_public_path__ + "static/media/Q16.545dbe72.jpg";